import React, { Fragment, useEffect } from 'react';
import { useListStocksQuery } from '../../../redux/api/stockApi';
import { useSelector } from 'react-redux';

const ListStocks = () => {
  const curEvent = useSelector((state) => state.auth.currentEvent);
  const { data: stocks, isLoading } = useListStocksQuery(
    { eventId: curEvent?.id },
    { skip: !curEvent?.id }
  );

  if (isLoading) {
    return <p>Bestände werden geladen...</p>;
  }

  // Hide empty rows (nothing available and nothing in transit) — they're just
  // noise on the overview.
  const visibleStocks = (stocks ?? []).filter(
    (stock) => stock.quantity_available !== 0 || stock.quantity_in_transit !== 0
  );

  if (visibleStocks.length === 0) {
    return <p>Keine Bestände gefunden.</p>;
  }

  return (
    <Fragment>
      <h4>Bestände</h4>
      <table className='table table-striped mt-4 align-middle text-start'>
        <thead>
          <tr>
            <th>Lagerort</th>
            <th>Artikel</th>
            <th>Bestand verfügbar</th>
            <th>Bestand in Auslieferung</th>
          </tr>
        </thead>
        <tbody>
          {visibleStocks.map((stock, index) => (
            <tr key={index}>
              <td>{stock.storage_name}</td>
              <td>{stock.article_name}</td>
              <td>{stock.quantity_available}</td>
              <td>{stock.quantity_in_transit}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Fragment>
  );
};

export default ListStocks;
